import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleTextArea from "../../../modules/simpleTextArea";
import FlexView from "react-flexview";
import SimpleSpacerLine from "../../../modules/SimpleSpacerLine";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import {TABLE_COLUMN_DETAIL_CONFIG} from "./config";
import SimpleButton from "../../../modules/commons/SimpleButton";
import CustomerProfileCDBModifyingInputHeader from "./customerProfileCDBModifyingInputHeader";
import CustomerProfileCDBDetailHistoryService from "./customerProfileCDBDetailHistoryService";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import {contructQueryParam, fetchDataAsync} from "../../../Services/Utils";
import Api from "../../../Services/Api";
import {HttpStatus} from "../../common/Constants";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import * as R from "ramda";

class CustomerProfileCDBModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalModifyingVisible: false,
            updateAlertVisible: false,
            tableColumns: this.getTableColumns(),
            dataTable: [],
            data: {},
            responseContent: null
        }
    }

    getTableColumns() {
        let columns = [...TABLE_COLUMN_DETAIL_CONFIG];
        columns.push({
            name: "action",
            label: "Aksi",
            options: {
                customBodyRender: (_, tableMeta) => (
                    <>
                        <SimpleButton
                            type="button"
                            category="action_button"
                            text="Proses Ekspedisi"
                            icon={<i className="fa fa-lg fa-eye"/>}
                            onClick={() => this.handleModalModifyingVisibility(tableMeta.rowIndex)}
                        />
                    </>
                ),
            },
        })

        return columns;
    }

    async componentDidMount() {
        this.handleTriggerLoading();
        const queryParam = contructQueryParam({customerId: this.props.selectedData?.customerId});
        await this.fetchData(queryParam);
        this.handleTriggerLoading();
    }

    handleModalModifyingVisibility = (index) => {
        this.setState((prevState) => ({
            ...prevState,
            modalModifyingVisible: !prevState.modalModifyingVisible,
            selectedData: prevState.dataTable[index],
        }))
    }

    handleValueChange = async (name, value) => {
        // if name is note, do validation for marketing line
        if (R.equals(name, "fotoProfilBase64")) {
            this.handleTriggerLoading();
            const requestBody = {
                customerId: this.props.selectedData?.customerId,
                fotoProfilBase64: value
            }
            await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").uploadProfilePictureCDB,
                setError: this.props.setError,
                menuName: "CDB - Customer Profile",
                args: requestBody,
            });
            this.handleTriggerLoading();
        }

        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [name]: value
            }
        }))
    }

    handleAlertUpdateVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            updateAlertVisible: !prevState.updateAlertVisible
        }))
    }

    handleAlertConfirmVisibility = (response) => {
        this.setState((prevState) => ({
            ...prevState,
            confirmAlertVisible: !prevState.confirmAlertVisible,
        }))
    }

    handleUpdate = async () => {
      this.handleTriggerLoading();
      const requestBody = {
        customerId: this.props.selectedData?.customerId,
        catatanKhusus: this.state.data.catatanKhusus
      };

      let res = await Api.create("NAGAMAS_TRANSACTION").updateSpecialNoteCDB(requestBody)

      if (res?.data.code === 201) {
        this.handleAlertUpdateVisibility();
      } else {
        this.setState((prevState) => ({
            ...prevState,
            updateAlertVisible: false,
            responseContent: res.data.message
        }))
        this.handleAlertConfirmVisibility();
      }

      this.handleTriggerLoading();
    };


    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (filter = {}) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailCDB,
            setError: this.props.setError,
            menuName: "CDB - Customer Profile",
            args: filter,
        });

        if (res.ok && res.data.status === HttpStatus.FAILED) {
            this.props.onClickClose();
        }

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                data: res.data.data,
                dataTable: res.data.data?.dataNosinCustomer
            }))
        }
    }

    render() {
        return (
            <>
                <SimpleModal
                    id="customerProfileCDBModifying"
                    title="Customer Profile"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <CustomerProfileCDBModifyingInputHeader
                                data={this.state.data}
                                onValueChange={this.handleValueChange}
                            />
                            <SimpleSpacerLine/>
                            <FlexView style={{justifyContent: "space-between"}}>
                                <FlexView column style={{width: "25%"}}>
                                    <SimpleInput
                                        id="input_text_kode_cabang_pemilik"
                                        name="kodeCabangPemilik"
                                        label="Kode Cabang Pemilik"
                                        readOnly
                                        value={this.state.data?.kodeCabangPemilik}
                                    />
                                    <SimpleTextArea
                                        id="input_text_hoby"
                                        typeInputCase="normal"
                                        name="hobby"
                                        label="Hoby"
                                        readOnly
                                        value={this.state.data?.dataHobby?.valueOf()[0]?.value}
                                    />
                                    <SimpleTextArea
                                        id="input_text_interest"
                                        typeInputCase="normal"
                                        name="interest"
                                        label="Interest"
                                        readOnly
                                        value={this.state.data?.dataInterest?.valueOf()[0]?.value}
                                    />
                                    <SimpleTextArea
                                        id="input_text_note"
                                        typeInputCase="normal"
                                        name="catatanKhusus"
                                        label="Catatan Khusus"
                                        errorMessage={this.state.errorData?.catatanKhusus}
                                        value={this.state.data?.catatanKhusus}
                                        onChange={(e) => this.handleValueChange(e.target.name, e.target.value)}
                                    />
                                    <SimpleButton
                                        className="margin-left-none"
                                        text="Update"
                                        onClick={this.handleAlertUpdateVisibility}
                                    />
                                </FlexView>
                                <FlexView column style={{gap: 20, width: "70%", marginTop: 20}}>
                                    <SimpleDataTable
                                        data={this.state.dataTable}
                                        toCount={0}
                                        rowsPerPage={5}
                                        page={0}
                                        columns={this.state.tableColumns}
                                        options={{serverSide: false}}
                                    />
                                    <SimpleInput
                                        id="input_text_jumlah_spending_dalam_1_tahun"
                                        name="jumlahSpending"
                                        label="Jumlah Spending Dalam 1 Tahun"
                                        style={{width: 200}}
                                        readOnly
                                        value={this.state.data?.jumlahSpending}
                                    />
                                </FlexView>
                            </FlexView>
                            <div className="grid grid-2x gap-20px grid-mobile-none paddingTop-20px">
                                <div id="grid-1"></div>
                                <div id="grid-2"></div>
                            </div>
                        </ModalContainer>
                    }
                />

                {this.state.modalModifyingVisible && (
                    <CustomerProfileCDBDetailHistoryService
                        id={this.props.selectedData?.nomorMesin}
                        selectedData={this.state.selectedData}
                        visible={this.state.modalModifyingVisible}
                        onClickClose={this.handleModalModifyingVisibility}
                    />
                )}

                {this.state.updateAlertVisible && (
                    <SimpleAlert
                        visible={this.state.updateAlertVisible}
                        title={"Confirmation"}
                        onClickClose={this.handleAlertUpdateVisibility}
                        content={
                            <div>
                                <p>Apakah yakin akan merubah catatan khusus? <br/>
                                    Jika "OK" Data tidak langsung berubah karena membutuhkan approval terlebih dahulu.
                                </p>
                                <FlexView hAlignContent="center">
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="Cancel"
                                        onClick={this.handleAlertUpdateVisibility}
                                    />
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="OK"
                                        onClick={this.handleUpdate}
                                    />
                                </FlexView>
                            </div>
                        }
                    />
                )}

                {this.state.confirmAlertVisible && (
                    <SimpleAlert
                        visible={this.state.confirmAlertVisible}
                        title={"Information"}
                        onClickClose={this.handleAlertConfirmVisibility}
                        content={
                            <div>
                                <p>{this.state.responseContent}</p>
                                <FlexView hAlignContent="center">
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="OK"
                                        onClick={this.handleAlertConfirmVisibility}
                                    />
                                </FlexView>
                            </div>
                        }
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(CustomerProfileCDBModifying);